// theirs
import styled from 'styled-components'
// ours
import { NextChapterProps } from '.'
import { breakpoints, typography } from '../../../styles'

export const nextChapterBaseClass = 'next-chapter'

export const StyledNextChapter = styled.div<NextChapterProps>`
    &.${nextChapterBaseClass} {
        display: grid;

        .content-outer {
            .content-inner {
                grid-template-rows: 1fr auto 1fr;
            }
        }

        .subtitle-wrapper {
            justify-items: center;
            place-self: center;
            align-self: end;
            margin-bottom: 1.5rem;
        }

        .title-wrapper {
            justify-items: center;
            place-self: center;
        }

        .link-wrapper {
            justify-items: center;
            place-self: center;
            align-self: start;
            display: grid;
            margin-top: 1.5rem;

            a {
                display: grid;
                grid-template-rows: 1fr 1fr;
                justify-items: center;

                @media (min-width: ${breakpoints.lg}) {
                    grid-template-columns: 1fr auto;
                    grid-template-rows: auto;
                    justify-items: auto;
                }
            }

            span {
                font-size: ${typography.size.m3};
                margin-right: 0;
                align-self: center;

                @media (min-width: ${breakpoints.lg}) {
                    margin-right: 1rem;
                }
            }

            svg {
                width: 100px;
            }
        }

        h2 {
            font-family: ${typography.type.secondary};
            font-weight: ${typography.weight.bold};
            font-style: ${typography.style.normal};

            color: ${(props) =>
                props.content.contentNextChapter?.contentNextChapterTitleColor};
            text-transform: uppercase;
            text-align: center;
            margin: 0;
            padding: 0;

            letter-spacing: normal;
            line-height: normal;

            font-size: ${typography.size.l5};
            @media (min-width: ${breakpoints.xs}) {
                font-size: ${typography.size.code};
            }
        }

        h4 {
            font-family: ${typography.type.secondary};
            font-weight: ${typography.weight.bold};
            font-style: ${typography.style.normal};
            font-size: ${typography.size.m3};
            color: ${(props) =>
                props.content.contentNextChapter
                    ?.contentNextChapterSubTitleColor};
            text-transform: uppercase;
            text-align: center;
            margin: 0;
            padding: 0;

            letter-spacing: normal;
            line-height: normal;
        }

        a {
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.64;
            letter-spacing: 0.88px;
            color: ${(props) =>
                props.content.contentNextChapter?.contentNextChapterHrefColor};
            padding: 0;
            text-decoration: none;
        }

        svg {
            margin: 0;

            polyline,
            line {
                fill: none;
                stroke: ${(props) =>
                    props.content.contentNextChapter
                        ?.contentNextChapterHrefColor};
                stroke-miterlimit: 10;
                stroke-width: 4px;
            }
        }
    }
`
